import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { moabUTConfig } from "./data";

export default function MoabUTPage() {
  return <CityPageTemplate config={moabUTConfig} />;
}